import {
	SET_REPORT_TYPES,
	SET_USER_LIST,
	SERVER_CREATE_NEW_USER,
	SERVER_UPDATE_USER_DATA,
	ADD_USER,
	UPDATE_USER,
	SET_USER_PROFILE,
	SET_RESPONSIBLE_AREAS,
	SET_NOTIFICATIONS,
	SERVER_DELETE_USER,
	DELETE_USER
} from 'constants/ActionTypes';

const INITIAL_STATE = {
	types: [],
	userList: [],
	userProfile: {
		userId: null,
		firstName: '',
		lastName: '',
		email: '',
		date: '',
		role: {
			id: ''
		}
	},
	notifications: [],
	responsibleAreas: [],
	settings: {
		minPasswordLength: 10,
		minPasswordCategories: 3
	},
	loading: {
		userList: true,
		userProfile: true,
		createNewUser: false,
		updateUser: false,
		deleteUser: false
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		// Meldungskategorien im Redux State speichern
		case SET_REPORT_TYPES:
			return { ...state, types: action.payload.types };
		// Benutzerliste im Redux State speichern
		case SET_USER_LIST:
			return { ...state, userList: action.payload.userList, loading: { ...state.loading, userList: false } };
		// Loadingflag für das Anlegen eines neuen Nutzers
		case SERVER_CREATE_NEW_USER:
			return { ...state, loading: { ...state.loading, createNewUser: true } };
		// Loadingflag für das aktualisieren von Nutzerdaten
		case SERVER_UPDATE_USER_DATA:
			return { ...state, loading: { ...state.loading, updateUser: true } };
		// Neuen Nutzer in die Nutzerliste aufnehmen
		case ADD_USER:
			return {
				...state,
				userList: [...state.userList, action.payload.user],
				loading: { ...state.loading, createNewUser: false }
			};
		// Nutzerdaten im Redux State aktualisieren
		case UPDATE_USER:
			return {
				...state,
				userList: state.userList.map(user => {
					return user.userId === action.payload.user.userId ? { ...user, ...action.payload.user } : user;
				}),
				loading: { ...state.loading, updateUser: false }
			};
		// Profildaten im Redux State speichern
		case SET_USER_PROFILE:
			return {
				...state,
				userProfile: action.payload.userProfile,
				loading: {
					...state.loading,
					userProfile: false
				}
			};
		// Verfügbare Zuständigkeitsgebiete in Redux State speichern
		case SET_RESPONSIBLE_AREAS:
			return {
				...state,
				responsibleAreas: action.payload.responsibleAreas
			};
		// Benachrichtigung des Nutzers im Redux State speichern
		case SET_NOTIFICATIONS:
			return {
				...state,
				notifications: action.payload.notifications
			};
		// Loadingflag  für das Löschen eines Nutzers
		case SERVER_DELETE_USER:
			return { ...state, loading: { ...state.loading, deleteUser: true } };
		// Nutzer aus der Nutzerliste löschen
		case DELETE_USER:
			return {
				...state,
				userList: state.userList.filter(user => user.userId !== action.payload.userId),
				loading: { ...state.loading, deleteUser: false }
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/General.js